import { render, staticRenderFns } from "./SupportDoneSwitch.vue?vue&type=template&id=9d5ec114&scoped=true&lang=pug"
import script from "./SupportDoneSwitch.vue?vue&type=script&lang=ts"
export * from "./SupportDoneSwitch.vue?vue&type=script&lang=ts"
import style0 from "./SupportDoneSwitch.vue?vue&type=style&index=0&id=9d5ec114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5ec114",
  null
  
)

export default component.exports